/*eslint no-control-regex: "off"*/
export const _href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/
